// extracted by mini-css-extract-plugin
export default {"itemContainer":"KMiga","defenition":"J6-1m","skeleton-progress":"JvDl-"};